//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET, TABLET_PLUS } from '@/scripts/constants/media-query'
import { mapGetters } from 'vuex'
import RbDate from '@/utils/rb-date'
import wcs from '@/scripts/libs/wcs'
const { checkPrescriptionIssueDate, showDoctorName, locale } = wcs.getStoreConfig()
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

export default {
  name: 'rb-rox-manual-prescription',
  props: {
    isThankYouPage: {
      type: Boolean,
      default: false,
    },
    manualPrescriptionObject: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data: () => {
    return {
      voidValueSymbol: '-',
    }
  },
  computed: {
    ...mapGetters(['translation']),
    tableValues() {
      return {
        lsphreading: this.manualPrescriptionObject.SPH?.OS || this.voidValueSymbol,
        lcycreading: this.manualPrescriptionObject.CYL?.OS || this.voidValueSymbol,
        laxisreading: this.manualPrescriptionObject.AX?.OS || this.voidValueSymbol,
        ladddetails: this.manualPrescriptionObject.ADD?.OS || this.voidValueSymbol,
        rsphreading: this.manualPrescriptionObject.SPH?.OD || this.voidValueSymbol,
        rcycreading: this.manualPrescriptionObject.CYL?.OD || this.voidValueSymbol,
        raxisreading: this.manualPrescriptionObject.AX?.OD || this.voidValueSymbol,
        radddetails: this.manualPrescriptionObject.ADD?.OD || this.voidValueSymbol,
        rhprysm: this.manualPrescriptionObject.HPRISM?.OD || this.voidValueSymbol,
        rvprysm: this.manualPrescriptionObject.VPRISM?.OD || this.voidValueSymbol,
        lhprysm: this.manualPrescriptionObject.HPRISM?.OS || this.voidValueSymbol,
        lvprysm: this.manualPrescriptionObject.VPRISM?.OS || this.voidValueSymbol,
        pupdistance: this.manualPrescriptionObject.PD?.OD || this.voidValueSymbol,
        rpupdistance: this.manualPrescriptionObject.PD?.OD || this.voidValueSymbol,
        lpupdistance: this.manualPrescriptionObject.PD?.OS || this.voidValueSymbol,
        issueDate: this.manualPrescriptionObject.issueDate || this.voidValueSymbol,
        doctorName: this.manualPrescriptionObject.doctorName || this.voidValueSymbol,
      }
    },
    isPupilaryDistanceASingleValue() {
      return !this.manualPrescriptionObject.PD?.OS
    },
    isMobileOrTablet() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === TABLET_PLUS
    },
    issueDateEnabled() {
      if (parseInt(checkPrescriptionIssueDate) !== 0) {
        const country = [
          WcsLocales.mapCountryCode(WcsLocales.EN_CA),
          WcsLocales.mapCountryCode(WcsLocales.FR_CA),
        ]
        return country.includes(WcsLocales.mapCountryCode(locale))
      }
      return false
    },
    doctorNameEnabled() {
      return showDoctorName
    },
    formattedIssueDate() {
      const onlyDate = this.manualPrescriptionObject.issueDate.split(' ')
      const formatDate = new Date(onlyDate[0]).getTime()

      if (formatDate) {
        return RbDate.formatDate(formatDate, 'MM/yyyy')
      }
      return ''
    },
  },
}
